import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledTriggerItemCard = styled.div`
	display: grid;
	gap: 16px;
	${breakPoints({
		'768': `grid-template-columns: auto 1fr`,
	})};

	.content-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: ${SYS_SPACE_FIXED_200};
	}

	.button-content {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_200};
		text-align: start;
	}
`;

export const StyledConflictItem = styled.div`
	display: grid;
	width: 100%;
	gap: 16px;
	${breakPoints({
		'768': `grid-template-columns: auto 1fr auto`,
	})};
`;

export const StyledImageOrButton = styled.div<{ autoHeight: boolean }>`
	position: relative;
	aspect-ratio: 16 / 9;
	height: 128px;
	width: 100%;
	flex-shrink: ${breakPoints({
		'768': `
			height: ${({ autoHeight }: { autoHeight?: boolean }) => (autoHeight ? 'auto' : 'full')};
			width: 208px;
		`,
	})};

	> img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.img-contain {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.img-cover {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const StyledItemInfo = styled.div`
	display: flex;
	gap: 16px;

	button {
		align-self: flex-start;
	}

	.content-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: ${SYS_SPACE_FIXED_200};
	}

	.clickable-content {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_200};
		text-align: start;
	}

	.grid-placement {
		display: grid;
	}
`;

export const StyledConflictItemContainer = styled.div`
	position: relative;
	display: flex;
	gap: ${SYS_SPACE_FIXED_200};
	border: 1px solid transparent;
	padding: ${SYS_SPACE_FIXED_200} 0;
	transition: colors 0.3s ease;
`;

export const StyledLoadingOverlay = styled.div`
	position: absolute;
	inset: 0;
	display: grid;
	place-items: center;
	background-color: rgba(255, 255, 255, 0.5);
`;

export const StyledCheckMark = styled.button<{ $checked: boolean }>`
	position: relative;
	display: grid;
	height: 1.5rem;
	width: 1.5rem;
	flex-shrink: 0;
	overflow: hidden;
	border-radius: 50%;
	text-align: center;
	color: white;
	transition: colors 0.3s ease;
	background-color: ${({ $checked }) => ($checked ? '#4d9e29' : 'transparent')};
	border: ${({ $checked }) => ($checked ? 'none' : '1px solid #e5e7eb')};

	.check-icon {
		position: absolute;
	}
`;
